
import React from "react";
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import saveFile from "../services/saveFile";
import Cookies from 'universal-cookie';
import uuid from 'react-uuid';
import Constants from "../utils/consts";
import Button from './Button';
import MyDatePicker from "./DatePickerIta";
import moment from 'moment';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import ImageSilentInput from "./ImageSilentInput";
import translateString from "../utils/Locales";
import getClient from "../services/getClient";
import getRataStatus from "../services/getRataStatus";
import Utils from "../utils/utils";
import { NineCellLoading } from 'react-loadingg';
import loadDocument from "../services/loadDocument";

let tr = translateString;

export default class UploadDocument extends React.Component {

    constructor(props) {
        super(props);
        this.count = 0;
        this.state = {
            message: undefined,
            file: undefined,
            alertName:false,
            alertFile:false,
        }
    }

    render() {
        return (

            <div>
                <div style={container} onClick={() => { this.setState({ visible: false }); this.props.onClose(); }}>
                    <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                        {this.state.isLoading ? <NineCellLoading /> : (<div>
                            <div style={closeBtn} onClick={() => {
                                this.setState({ visible: false });
                                this.props.onClose();
                                }}
                            >
                                <img alt="" src={require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                            </div>
                            <div style={windowTitle}>{tr('nuovo_file')}</div>
                            <br/>
                            <input 
                                style={{...input, backgroundColor:'#eeeeee'}}
                                type="text" 
                                placeholder={tr('inserisci_nome')} 
                                value={this.state.message} 
                                onChange={(value) => {
                                    this.setState({message: value.target.value, alertName:false});
                                }}
                            />
                            {
                                this.state.alertName && (
                                    <div style={{marginTop:5, borderRadius: 10 ,width:300, height:32, padding:5, backgroundColor: 'rgba(255, 0, 0, 0.5)'}}>
                                        <p>{tr('inserisci_nome')}</p>
                                    </div>
                                )
                            }
                            <br />
                            <ImageSilentInput name={''} key={Math.random()}
                                value={this.state.imageToLoad}
                                onChange={async (base64) => {
                                    this.setState({filecontent: base64, alertFile:false});
                                }}
                            />
                            {
                                this.state.alertFile && (
                                    <div style={{marginTop:5, borderRadius: 10 ,width:300, height:32, padding:5, backgroundColor: 'rgba(255, 0, 0, 0.5)'}}>
                                        <p>{tr('inserisci_file')}</p>
                                    </div>
                                )
                            }
                            {
                                this.state.filecontent && (
                                    <div key={Math.random()} style={{ width: '300px', height: 45, boxShadow: '0px 1px 3px lightgrey',backgroundColor: '#F3F3F3', paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderRadius: 10, cursor: 'pointer', marginBottom: 16, marginLeft: 5  }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <img src={ require('../images/folder.png') } style={{ height: 30, width: 30, marginTop: 2.5 }} alt="File" />
                                        <p style={{ fontWeight: 'bold', color: 'darkgrey', marginLeft: 20, marginTop: 9, textTransform: 'none' }}>
                                            {tr('file')}
                                        </p>
                                    </div> 
                                    <img alt="" src={ require('../images/delete.png') } style={{ height: 20, width: 20, marginTop: 2.5, cursor: 'pointer', marginRight: 10, marginTop: 7 }} title={tr('elimina_immagine')} onClick={(e) => { 
                                        e.stopPropagation();  
                                        if (window.confirm(tr('elimina_immagine')) == false) return;
                                        this.setState({filecontent: undefined})
                                    }} />
                                </div>
                                    )
                            }
                            
                            <br/>
                            <Button callback={()=>{
                                const cookies = new Cookies();
                                const token = cookies.get('token', { path: '/' });
                                const username = cookies.get('username', { path: '/' });
                                let message = this.state.message;
                                let filecontent = this.state.filecontent;

                                if ( message == null|| message.trim().length === 0) {
                                    this.setState({alertName: true})
                                } else if (!filecontent) {
                                    this.setState({alertFile: true})
                                } else {
                                    loadDocument(username, token, this.props.corso.id, message, filecontent).then((resp)=> {
                                            if (resp.result == 'ok') {
                                                Utils.showSuccess(tr('file_inserito'));
                                                this.props.onClose();
                                            } else 
                                                Utils.showError(tr('errore_imprevisto'));
                                        })
                                }
                            }} title={tr('salva')}></Button>
                        </div>)}
                    </div>
                </div>
            </div>
        )
    }


}

const input = {
    width: '300px',
    padding: '10px',
    borderLeft: 0, 
    borderTop: 0, 
    borderRight: 0, 
    borderBottom: '1px solid darkgrey'
}

const windowTitle = {
    color: 'darkgrey',
    fontSize: 30,
    fontWeight: 'bold',
    fontFamily: 'Teko',
    textAlign: 'left',
    marginLeft: 5,
}

const closeBtn = {
    position: 'absolute',
    cursor: 'pointer',
    right: 10,
    top: 10,
    padding: 10,
    zIndex: 999,
}

const container = {
    position: 'fixed',
    display: 'block',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    minWidth: '100%',
    minHeight: '100%',
    backgroundColor: '#3C3C3C4D',
    overflowY: 'scroll',
    overflowX: 'hidden',
};

const mainClass = {
    paddingBottom: 10,
    position: 'absolute',
    left: 'calc((100% - 400px)/2',
    top: '100px',
    minWidth: '350px',
    maxHeight: 350,
    minHeight: 350,
    width: '350px',
    background: 'white',
    padding: '20px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px',
    bottom: '30px',
}